module.exports = __webpack_public_path__ + "img/TCC-L6-Pagina1 A.d893a1a7.png";